// extracted by mini-css-extract-plugin
export default {"label":"nuRWS","rangeInput":"_3k2yJ"};